import { useMemo } from 'react';
import { useCarEBoxLocations, useCarOperations } from 'entities/cars';

import { getCarIcon } from '../utils';

import { HereLayer } from 'common/utils/MapMarker/types';
import { CarEBoxLocation } from 'entities/cars';

import { NavigationAutoCoordinates } from 'entities/navigation';

import { EMPTY_ARRAY } from 'shared/constants';


export const useCarMarkersLayer = () => {
  const carEBoxLocations = useCarEBoxLocations();
  const { setSelectedCarEBoxLocation } = useCarOperations();

  const carMarkersLayer = useMemo((): HereLayer<NavigationAutoCoordinates[]> => ({
    data: carEBoxLocations || EMPTY_ARRAY as any,
    name: 'cars',
    type: 'marker',
    getCoordinates: ({
      data: {
        latitude,
        longitude
      }
    }) => ({
      latitude,
      longitude
    }),
    getIcon: ({ data }) => {
      const {
        url,
        height,
        width
      } = getCarIcon({
        properties: {
          cluster: false,
          ...data
        }
      });

      return ({
        url,
        height,
        width,
        anchorY: height,
        anchorX: width / 2,
        id: data.autoNumber
      });
    },
    onClick: ({ data }: any) => {
      setSelectedCarEBoxLocation(data as any as CarEBoxLocation);
    }
  }), [
    carEBoxLocations,
    setSelectedCarEBoxLocation
  ]);

  return carMarkersLayer;
};
